//--------------- IMPORTAÇÕES ---------------//
import { X } from "lucide-react";
import { useContext } from "react";
import { toast } from "react-toastify";
import Papa from "papaparse";
import { LeadsContext } from "../../context/LeadsContext";
import { importBatchService } from "../../services";



//--------------- EXPORTAÇÃO DO MODAL IMPORT LEADS ---------------//
export default function ModalImportLeads() {



  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const { inputRef } = useContext(LeadsContext);
  const { showCreate, setShowCreate } = useContext(LeadsContext);
  const { progress, setProgress } = useContext(LeadsContext);
  const { isImporting, setIsImporting } = useContext(LeadsContext);
  const { dataCsv, setDataCsv } = useContext(LeadsContext);
  const { result, setResult } = useContext(LeadsContext);
  const { isOpenModalImport, setIsOpenModalImport } = useContext(LeadsContext);
  const { csvPreview, setCsvPreview } = useContext(LeadsContext);
  const { colMap, setColMap } = useContext(LeadsContext);
  const { tagsAvailable, setTagsAvailable } = useContext(LeadsContext);
  const { tagSearched, setTagSearched } = useContext(LeadsContext);
  const { tagsSelected, setTagsSelected } = useContext(LeadsContext);
  const { itemsPerPage, setItemsPerPage } = useContext(LeadsContext);
  const { currentPage, setCurrentPage } = useContext(LeadsContext);
  const { filterStatus, setFilterStatus } = useContext(LeadsContext);
  const { filterTag, setFilterTag } = useContext(LeadsContext);
  const { total, setTotal } = useContext(LeadsContext);
  const { integrationsFilter, setIntegrationsFilter } = useContext(LeadsContext);



  //--------------- CRIAÇÃO DE VARIÁVEIS ---------------//
  const colsImported = Object.keys(csvPreview[0] || {});
  const suggestions = tagsAvailable.filter(t => t.nome.toLowerCase().includes(tagSearched.toLowerCase()));



  //------------ FUNÇÃO ASSÍNCRONA HANDLE REFRESH LEADS ------------//
  // Responsável por atualizar as leads via API
  // É utilizada a cada mudança nos hooks "currentPage", "itemsPerPage", "filterStatus" e "filterTag"
  // Armazena as leads no Estado "leads"
  // Armazena o total no Estado "total"
  async function handleRefreshLeads() {
    const offset = (currentPage - 1) * itemsPerPage;
    const term = "";
    const response = await loadLeadsService(itemsPerPage, offset, term, filterStatus, filterTag, integrationsFilter);
    if (response) {
      setLeads(response.data.leads);
      setTotal(response.data.total);
    }
  };



  //--------------- FUNÇÃO HANDLE READ CSV ---------------//
  function handleReadCsv(file) {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const preview = results.data.slice(0, 5);
        setCsvPreview(preview);
        setDataCsv(results.data);
      },
      error: (err) => {
        toast.error("Erro ao ler o CSV");
        console.error(err);
      },
    });
  };



  //--------------- FUNÇÃO ASSÍNCRONA HANDLE BATCH IMPORT ---------------//
  async function handleBatchImport() {
    const tamanhoLote = 100;
    const total = dataCsv.length;
    let enviados = 0;
    let inseridos = 0;
    let atualizados = 0;

    setIsImporting(true);
    setResult(null);

    for (let i = 0; i < total; i += tamanhoLote) {
      const lote = dataCsv.slice(i, i + tamanhoLote);

      const loteCorrigido = lote.map(row => {
        if (colMap.tags && row[colMap.tags]) {
          try {
            const corrigido = row[colMap.tags]
              .replace(/^"\[|\]"$/g, '')
              .replace(/""/g, '"')
              .replace(/","/g, '|||')
              .replace(/"/g, '')
              .split('|||')
              .map(t => t.trim())
              .filter(Boolean);
            row[colMap.tags] = corrigido;
          } catch {
            row[colMap.tags] = [];
          }
        }
        return row;
      });

      const data = {
        dados: loteCorrigido,
        colMap,
        tags_manuais: tagsSelected
      }


      const response = await importBatchService(data);
      if (response) {
        enviados += lote.length;
        setProgress(Math.round((enviados / total) * 100));
        inseridos += response.data.inseridos || 0;
        atualizados += response.data.atualizados || 0;
      }
      else {
        setIsImporting(false);
      }
    }

    setResult({ inseridos, atualizados });

    setTimeout(() => {
      setIsImporting(false);
      setProgress(0);
      handleRefreshLeads();
    }, 1000);
  };



  //--------------- FUNÇÃO HANDLE FILE ---------------//
  const handleFile = (e) => {
    const file = e.target.files[0];
    if (file) handleReadCsv(file);
  };



  //--------------- FUNÇÃO HANDLE TAG CHANGE ---------------//
  const handleTagChange = (e) => {
    const val = e.target.value;
    setTagSearched(val);
    setShowCreate(val.length > 2 && !suggestions.some(t => t.nome === val));
  };



  //--------------- FUNÇÃO HANDLE CREATE TAG ---------------//
  const handleCreateTag = () => {
    if (tagSearched && !tagsSelected.includes(tagSearched)) {
      handleAddTag(tagSearched);
      setTagSearched("");
      setShowCreate(false);
    }
  };



  //--------------- FUNÇÃO HANDLE ADD TAG ---------------//
  const handleAddTag = (tag) => {
    if (!tagsSelected.includes(tag)) {
      setTagsSelected([...tagsSelected, tag]);
    }
    setTagSearched("");
  };



  //--------------- RETORNO CONDICIONAL DO MODAL IMPORT LEADS ---------------//
  return (
    <>
      {!isOpenModalImport
        ? null
        :
        <>
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-surface-1 border border-white/[0.08] rounded-xl w-full max-w-5xl p-6 max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Importar Leads</h2>
                <button onClick={() => setIsOpenModalImport(false)}><X className="text-white" /></button>
              </div>

              <input type="file" ref={inputRef} onChange={handleFile} className="mb-4 w-full" />

              <div className="mb-6">
                <label className="text-sm font-medium">Tags para aplicar:</label>
                <input
                  type="text"
                  value={tagSearched}
                  onChange={handleTagChange}
                  placeholder="Buscar ou criar nova tag"
                  className="bg-surface-2 px-3 py-2 rounded border border-white/[0.08] w-full mt-1"
                />
                <div className="mt-2 flex gap-2 flex-wrap">
                  {suggestions.slice(0, 5).map(tag => (
                    <button
                      key={tag.id}
                      onClick={() => handleAddTag(tag.nome)}
                      className="bg-surface-3 hover:bg-brand-600 px-2 py-1 rounded text-xs"
                    >
                      {tag.nome}
                    </button>
                  ))}
                  {showCreate && (
                    <button
                      onClick={handleCreateTag}
                      className="bg-green-600 hover:bg-green-700 px-2 py-1 rounded text-xs text-white"
                    >
                      Criar nova tag "{tagSearched}"
                    </button>
                  )}
                </div>
                <div className="mt-2 flex gap-2 flex-wrap">
                  {tagsSelected.map(t => (
                    <span key={t} className="bg-brand-600 px-2 py-1 rounded text-xs">{t}</span>
                  ))}
                </div>
              </div>

              {csvPreview.length > 0 && (
                <div className="overflow-x-auto">
                  <table className="min-w-full text-sm border border-white/[0.08]">
                    <thead className="bg-surface-3">
                      <tr>
                        {colsImported.map((col, idx) => (
                          <th key={idx} className="p-2 whitespace-nowrap max-w-[150px] truncate">
                            <div>{col}</div>
                            <select
                              className="bg-surface-2 text-white mt-1 text-xs rounded w-full"
                              value={Object.entries(colMap).find(([_, v]) => v === col)?.[0] || ""}
                              onChange={(e) => {
                                const novoMap = { ...colMap };
                                const campoSelecionado = e.target.value;
                                Object.entries(novoMap).forEach(([key, val]) => {
                                  if (val === col && key !== campoSelecionado) novoMap[key] = "";
                                });
                                novoMap[campoSelecionado] = col;
                                setColMap(novoMap);
                              }}
                            >
                              <option value="">Ignorar</option>
                              <option value="nome">Nome</option>
                              <option value="telefone">Telefone</option>
                              <option value="email">Email</option>
                              <option value="tags">Tags</option>
                            </select>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {csvPreview.map((row, i) => (
                        <tr key={i} className="border-t border-white/[0.08]">
                          {colsImported.map((col, j) => (
                            <td key={j} className="p-2 max-w-[150px] truncate whitespace-nowrap">
                              {Array.isArray(row[col]) ? row[col].join(", ") : row[col]}
                            </td>))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {isImporting && (
                <div className="w-full bg-surface-3 rounded-full h-2 mt-4">
                  <div
                    className="bg-brand-600 h-2 rounded-full"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
              )}

              {result && (
                <div className="text-sm text-ink-2 mt-4">
                  {result.inseridos} leads inseridos, {result.atualizados} atualizados com sucesso.
                </div>
              )}

              <div className="text-right mt-6">
                <button
                  onClick={handleBatchImport}
                  className="px-6 py-2 bg-brand-600 hover:bg-brand-700 rounded"
                  disabled={isImporting}
                >
                  {isImporting ? "Importando..." : "Importar"}
                </button>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}
